import React from "react";
import "./Header.css";
import SearchIcon from "@material-ui/icons/Search";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./Firebase";
const Header = () => {
	const [{ basket, user }, dispatch] = useStateValue();

	const authenticationHandler = () => {
		if (user) {
			auth.signOut();
		}
	};

	return (
		<div className="header">
			<Link to="/" style={{ textDecoration: "none" }}>
				<img
					className="header__logo"
					src="http://pngimg.com/uploads/amazon/amazon_PNG25.png"
					alt="header__logo"
				/>
			</Link>
			<div className="header__search">
				<input className="header__searchInput" type="text"></input>
				<SearchIcon className="header__searchIcon" />
			</div>
			<div className="header__nav">
				<Link to={!user && "/login"} style={{ textDecoration: "none" }}>
					<div onClick={authenticationHandler} className="header__option">
						<span className="header__optionLine1">
							Hello {user?.email.slice(0, user.email.indexOf("@"))}
						</span>
						<span className="header__optionLine2">
							{user ? "Sign Out" : "Sign In"} ▼
						</span>
					</div>
				</Link>
				<div className="header__option">
					<span className="header__optionLine1">Returns</span>
					<span className="header__optionLine2">& Orders</span>
				</div>
				<Link to="/addproduct" style={{ textDecoration: "none" }}>
					<div className="header__option">
						<span className="header__optionLine1">Add</span>
						<span className="header__optionLine2">Products</span>
					</div>
				</Link>
				<div className="header__option">
					<span className="header__optionLine1">Your</span>
					<span className="header__optionLine2">Prime</span>
				</div>
				<Link to="/checkout" style={{ textDecoration: "none" }}>
					<div className="header__optionBasket">
						<LocalMallIcon className="header_basket" />
						<span className="header__optionLine2 header__basketCount">
							{basket?.length}
						</span>
					</div>
				</Link>
			</div>
		</div>
	);
};

export default Header;
